// extracted by mini-css-extract-plugin
export default {"wrap":"QF-z","articleImagesWrap":"RF-z","articleImage":"SF-z","singleImage":"TF-z"};